export enum ELeaderboardTabsValues {
  weekly = '1',
  total = '2',
}

export enum EQuestsTabsValues {
  daily = '1',
  general = '2',
}
